import axios from "axios";
import { API_URL } from "../constants";

export const fetchTabUsers = (companyId, filtersValue = {}) => {
  const url = `${API_URL}/${companyId}/signontab/tab-user/fetch`;
  return axios
    .post(url, { filtersValue })
    .then((response) => response.data);
};

export const postTabUser = (data, companyId) => {
  const url = `${API_URL}/${companyId}/signontab/tab-user/post`;
  return axios.post(url, data).then((response) => response.data);
};

export const patchTabUser = (data, companyId) => {
  const url = `${API_URL}/${companyId}/signontab/tab-user/${data.id}`;
  return axios.patch(url, data).then((response) => response.data);
};

export const uploadToSignontab = (companyId, payload) => {
  const url = `${API_URL}/${companyId}/signatures/signontab/upload`;
  return axios.post(url, payload).then((response) => response.data);
};
